import styled from 'styled-components/macro';
import colors from 'Application/theme/colors';

const H6 = styled.h6`
	margin-top: 0;
	margin-bottom: 20px;
	color: ${colors.text.primary};
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	text-transform: none;
`;

export default H6;
